import processingApplicationDrafts from "./processingApplicationDrafts";
import config from "../../conf/config";

const processingApplicationDraftService = [{
    matcher: 'processingApplicationDrafts',
    reply: config => {
        return [200, processingApplicationDrafts]
    }
},{
    matcher: /processingApplicationDrafts\/(.*)/,
    reply: config => {
        const id = /processingApplicationDrafts\/(.*)/.exec(config.url)[1];
        const data = processingApplicationDrafts.find(application => application.appNo === id)
        return [200, data];
    }
}

]

export default processingApplicationDraftService;